<template>
    <div id="html-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="container">
                <div class="head" v-if="moduleData.Title && moduleData.ShowTitle">
                    <p class="heading">{{moduleData.Title}}</p>
                </div>
                <div class="body">
                    <div class="blog-media" v-if="moduleData.FeaturedImage && moduleData.FeaturedImage.ID">
                        <img :src="moduleData.FeaturedImage.URL">
                    </div>
                    <div class="blog-media" v-if="moduleData.FeaturedVideo">
                        <video preload="auto">
                            <source type="video/mp4" :src="moduleData.FeaturedVideo">
                        </video>
                        <div class="play-overlay">
                            <button><i class="fal fa-play"></i></button>
                        </div>
                    </div>

                    <div class="blog-content">
                        <p class="caption" v-if="moduleData.Caption">{{moduleData.Caption}}</p>
                        <div class="summary wysiwyg" v-if="moduleData.ParsedTopSummary" v-html="moduleData.ParsedTopSummary"></div>
                        <div class="content wysiwyg" v-if="moduleData.ParsedTopContent" v-html="moduleData.ParsedTopContent"></div>

                        <vue-glide class="gallery" :perView="1" type="carousel" v-if="moduleData.GalleryImages">
                            <vue-glide-slide v-for="(image, index) in moduleData.GalleryImages" :key="'image' + index">
                                <img :src="image.URL">
                            </vue-glide-slide>
                            <template slot="control">
                                <button class="glide__bullet" v-for="(image, index) in moduleData.GalleryImages" :key="index"
                                        :data-glide-dir="'=' + index"></button>
                            </template>
                        </vue-glide>

                        <div class="content wysiwyg" v-if="moduleData.ParsedBottomContent" v-html="moduleData.ParsedBottomContent"></div>
                    </div>
                    <div class="action">
                        <a class="btn btn-dark shadow-heavy" v-if="moduleData.CTA && moduleData.CTA.ID" :href="moduleData.CTA.URL">{{moduleData.CTA.CTAText}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {Glide, GlideSlide} from 'vue-glide-js';

    export default {
        name: "HTMLElement",
        components: {
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        }
    }
</script>
